export default {
  studea_manager: {
    confirm_duplication: "Êtes-vous sur de vouloir dupliquer ces données ?",
    data_duplicated_success: "Données dupliquées avec succès",
    delete_session_confirmation: "Êtes-vous sûr de vouloir supprimer cette période ?",
    delete_referential_confirmation: "Êtes-vous sûr de vouloir supprimer ce référentiel ?",
    navigation: {
      general: "Général",
      modules: "Modules",
      pilotage: "Pilotage",
    },
    triadUser: {
      title: "utilisateur secondaire",
    },
    moderation: {
      title: ({ plural }) => plural(["Signalement", "Signalements"]),
      censor: "Censurer",
      restore: "Annuler le signalement",
      show: "Voir",
      show_censor: "Voir les messages censurés",
      show_message: "Voir les messages à modérer",
      file: "Fichier",
      modal_title: "Conversation",
      alert_title: "Censurer un message",
      alert_sub_title: "Voulez-vous censurer ou annuler le signalement sur ce message ?",
      censor_success: "Message censuré avec succès !",
    },
    home: {
      title: ({ plural }) => plural(["Configuration de la ", "Configuration du "]),
      page_title: "Configuration",
    },
    trainingSkillCategory: {
      title: ({ plural }) => plural(["Bloc de compétence", "Blocs de compétence"]),
      block: ({ plural }) => plural(["Bloc", "Blocs"]),
    },
    questionnaire: {
      title: ({ plural }) => plural(["Questionnaire", "Questionnaires"]),
      list: {
        title: "Configuration des questionnaires",
      },
      questionnaire_already_signed: "Attention le questionnaire a déjà été signé !",
      start_date: ({ named }) => `Date d'accès ${named("profile")} - du`,
      end_date: "au",

      finish: {
        title: "Terminer ma configuration",
      },
      empty_title: "Pour commencer, veuillez ajouter un titre, une question ou une grille de réponse !",
      add_question: "Ajouter une question",
      add_title: "Ajouter un titre",
      add_question_cluster: "Ajouter une grille de questions",
      required: "Obligatoire",
      question_settings: "Paramètre de la question",
      question_access: "Paramètre des accès",
      cluster_settings: "Paramètre de la grille",
      remove_question: "Supprimer la question",
      remove_cluster: "Supprimer la grille",
      remove_title: "Supprimer le titre",
      duplicate_cluster: "Dupliquer la grille",
      duplicate_question: "Dupliquer la question",
      tip: "Infobulle",
      display_mode: "Grille de réponse",
      save: "Enregistrer",
      save_success: "Questionnaire enregistré avec succès !",
      save_error: "Il y'a eu une erreur lors de l'enregistrement !",
      missing_error: "Attention il manque certains droits d'accès ou des titres aux questions !",
      informations: "Informations",
      deadlines_reminders: "Échéances & relances",
      advanced_parameter: "Paramètres avancés",
      company_visit: "Visite en entreprise",
      settings: "Paramètres",
      summary: "Synthèse",
      add_column: "Ajouter une colonne",
      add_row: "Ajouter une ligne",
      row_settings: "Qui remplit ?",
      skill_settings: "Gérer les compétences liées",
      access_missing: "Les droits d'accès sont manquants pour cette question",
      title_missing: "Vous devez renseigner un titre pour cette question",
      value_title_missing: "Vous devez renseigner un titre pour cette valeur",
      duplicate_row: "Dupliquer la ligne",
      remove_row: "Supprimer la ligne",
      remove_column: "Supprimer la colonne",
      empty_line: "Ligne sans titre",
      add_skill: "Ajouter cette compétence",
      skill_category_name: "Catégorie",
      skill_name: "Nom",
      coefficient: "Coefficient",
      empty_column: "Titre de la colonne",
      remove_field_skill: "Suppression de la compétence liée",
      field_skill_used: "Cette compétence est déjà liée à cette question",
      remove_field_skill_sub: "Êtes-vous sûr de vouloir supprimer la liaison de cette compétence avec la question ?",
      untitled_column: "Colonne sans titre",
      remove_row_warning: "Êtes-vous sûr de vouloir supprimer cette ligne ?",
      remove_column_warning: "Êtes-vous sûr de vouloir supprimer cette colonne ?",
      untitled_questionnaire: "Formulaire sans titre",
      placeholder_description: "Ajouter votre description",
      access_profil: "Profils répondant à la question",
      field_skill: "Compétences liées à la question",
      search_skill: "Rechercher une compétence",
      opened_question_access: "Accès au questions ouvertes",
      opened_questions: "Questions ouvertes",
      opened_questions_type: "Type de questions ouvertes",
      grid_title: "Titre de la grille",
      comments_enabled: "Commentaires autorisés",
      comments_label: "Intitulé des commentaires",
      comments_type: "Type de champs commentaires",
      one_line: "Réponse courte",
      multi_line: "Zone de texte",
      maximal_mark: "Note maximum",
      mark_scale: "Barème",
      display_mark: "Utiliser les notes",
      display_radar: "Afficher le radar",
      question_title: "Titre de la question",
      infobulle_content: "Contenu de l'infobulle",
      question_comment: "Commentaire",
      field_type_choose: "Choisissez un type",
      short_answer: "Réponse courte",
      long_answer: "Réponse longue",
      textarea: "Zone de texte",
      number: "Nombre",
      dropdown_list: "Liste déroulante",
      unique_choice: "Choix unique",
      multiple_choices: "Choix multiples",
      file: "Fichier",
      date: "Date",
      question: ({ plural }) => plural(["question", "questions"]),
      date_time: "Date et heure",
      remove_question_warning: "Êtes-vous sûr de vouloir supprimer cette question ?",
      option: "Option",
      untitled_cluster: "Grille sans titre",
      untitled_title: "Title",
      title_label: "Titre",
      remove_cluster_warning: "Êtes-vous sûr de vouloir supprimer cette grille ?",
      value: "Valeur",
      choose_option: "Choisissez une option",
      questionnaire_settings: "Paramétrage du questionnaire",
      confirm: "Confirmer",
      cancel: "Annuler",
      rights: "Droits",
      notes_summary: "Notes et synthèse",
      option_placeholder: "Option",
      value_placeholder: "Note",
      comment_placeholder: "Ajouter un commentaire",
      option_settings: "Configuration des options",
      columns: "Colonnes",
      active: "Actif",
      unable: {
        confirmation: "Êtes-vous sûr de vouloir activer ce questionnaire ?",
        success: "Questionnaire activé avec succès !",
      },
      disable: {
        confirmation: "Êtes-vous sûr de vouloir désactiver ce questionnaire ?",
        success: "Questionnaire désactivé avec succès !",
      },
      global_export_visibility: "Visible sur l'export global du livret",
    },
    category: {
      title: ({ plural }) => plural(["Catégorie", "Catégories"]),
      add: "Ajouter une catégorie",
      delete_with_links: {
        title: "Supprimer la catégorie liée",
        sub_title:
          "Cette catégorie est reliée à des questionnaires, vous devez supprimer ces questionnaires afin de pouvoir supprimer cette catégorie. Voulez-vous vraiment continuer ?",
        success: "Catégorie liée supprimée avec succès !",
      },
    },
    mission: {
      title: ({ plural }) => plural(["Mission", "Missions"]),
    },
    group: {
      title: ({ plural }) => plural(["Groupe", "Groupes"]),
    },
    training: {
      title: ({ plural }) => plural(["Formation", "Formations"]),
      go_to_list: "Accéder à la liste des formations",
    },
    webLink: {
      title: ({ plural }) => plural(["Lien utile", "Liens utiles"]),
    },
    trainingCourse: {
      title: ({ plural }) => plural(["Promotion", "Promotions"]),
    },
    skill: {
      title: ({ plural }) => plural(["Compétence", "Compétences"]),
      list: {
        title: "Configuration des compétences",
        empty:
          "Il n'y a pas encore de compétence sur cette formation, veuillez créer une première catégorie pour commencer",
        empty_only: "Il n'y a pas encore de compétence renseignée",
      },
      actions: {
        add: "Ajouter une compétence",
        module_actions: "Configuration",
        skill_actions: "Gérer les compétences",
        session_actions: "Gérer les périodes",
        import_export_actions: "Import/Export",
        reminder_actions: "Relances",
      },
      name: "Nom",
      level: "Niveau requis",
      default: {
        not_acquired: "Non acquis",
        acquired: "Acquis",
        expert: "Expert",
        being_acquired: "En cours d'acquisition",
        insufficient_mastery: "Maîtrise insuffisante",
        partial_mastery: "Maîtrise partielle",
        average_mastery: "Maîtrise moyenne",
        good_mastery: "Maîtrise bonne",
        excellent_mastery: "Maîtrise excellente",
      },
    },
    skill_configuration: {
      title: "Configuration du module",
      success: "Configuration mis à jour avec succès !",
      use_admin: "Utiliser la configuration admin ?",
      warning:
        "Attention ! Vous devez terminer la configuration du module des compétences afin de pouvoir intégrer un référentiel",
    },
    skill_referential: {
      title: "Gestion des référentiels de compétences",
      success: "Référentiels mis à jour avec succès !",
      warning:
        "Attention ! Vous devez terminer la configuration du module des compétences afin de pouvoir intégrer un référentiel",
      empty_add: "Il n'y a pas encore de référentiel, veuillez cliquer sur '+' pour en ajouter un",
    },
    skill_generate: {
      title: "Générer un questionnaire à partir des compétences",
      success: "Questionnaire généré avec succès !",
    },
    skill_remove: {
      title: "Supprimer le référentiel (sans les questionnaires)",
      sub_title: "Êtes-vous sûr de vouloir supprimer le référentiel",
      success: "Référentiel supprimé avec succès !",
    },
    skill_import: {
      title: "Importer vos compétences",
      success: "Compétences importées avec succès !",
    },
    skill_import_france_competence: {
      title: "Importer le référentiel France Compétences",
      confirm: "Êtes-vous sûr de vouloir charger le référentiel France Compétences sur cette formation ?",
      success: "Référentiel importé avec succès !",
    },
    skill_export: {
      title: "Exporter les compétences",
      success: "Compétences exportées avec succès !",
    },
    skill_export_taught: {
      title: "Exporter les matières",
      success: "Matières exportées avec succès !",
    },
    skillSession: {
      gestion: "Gestion des périodes de compétences",
      list: {
        title: "Configuration des périodes",
        empty: "Il n'y a pas encore de période, veuillez cliquer sur '+' pour en ajouter une",
      },
      title: ({ plural }) => plural(["Période", "Périodes"]),
    },
    skillReferential: {
      title: ({ plural }) => plural(["Référentiel", "Référentiels"]),
      use: "Utiliser un référentiel",
    },
    skillCategory: {
      title: ({ plural }) => plural(["Catégorie", "Catégories"]),
    },
    skin: {
      title: ({ plural }) => plural(["Habillage", "Habillages"]),
      list: {
        title: "Habillage",
      },
    },
    gradebook: {
      title: ({ plural }) => plural(["Bulletin de note", "Bulletins de note"]),
      global_config: "Entête et pied de page",
      session_config: "Configuration des périodes",
      exam_type: "Liste des types d'examens",
      start_date: "Date d'ouverture : ",
      end_date: "Date de fermeture : ",
      empty_session: "Aucune période n'existe pour le moment, veuillez en ajouter une.",
      empty_subject: "Aucune matière n'est renseignée pour cette période, veuillez en ajouter une",
      empty_exam:
        "Aucun examen n'est renseigné pour cette matière, veuillez en selectionner un dans la configuration de la matière en cliquant ici",
      delete_session: {
        confirmation: "Êtes-vous sûr de vouloir supprimer cette période ?",
        success: "Période supprimée avec succès !",
      },
      delete_subject: {
        confirmation: "Êtes-vous sûr de vouloir retirer cette matière de la session ?",
        success: "Matière retirée avec succès !",
      },
      delete_exam: {
        confirmation: "Êtes-vous sûr de vouloir supprimer cet examen ?",
        success: "Examen retiré avec succès !",
      },
      scale: "Barème",
      set_exam_and_coef: "Renseigner le type d'examen et le coefficient pour cette matière",
    },
    exam: {
      title: ({ plural }) => plural(["Examen", "Examens"]),
      type_title: "Type d'examen",
    },
    triad: {
      title: ({ plural }) => plural(["Trinôme", "Trinômes"]),
      list: {
        name: "Nom",
        apprentice_name: "Nom de l'apprenti",
        tutor_name: "Nom du tuteur pédagogique",
        map_name: "Nom du tuteur entreprise",
        gestionnary_name: "Nom du gestionnaire",
      },
      tutor: {
        title: ({ plural }) => plural(["Tuteur pédagigique", "Tuteurs pédagigiques"]),
      },
      map: {
        title: ({ plural }) => plural(["Tuteur en entreprise", "Tuteurs en entreprise"]),
      },
      questionnaire_triad_already_signed:
        "Attention, des signatures de \nquestionnaires sont rattachées \nà ce trinôme",
      usurp: {
        title: "Incarner",
      },
      login: {
        title: "Gérer l'envoi des identifiants",
      },
      delete_all: {
        tutor: "Supprimer tous les tuteurs pédagogiques",
        map: "Supprimer tous les tuteurs en entreprise",
      },
      delete: {
        tutor: "Supprimer ce tuteur pédagogique",
        map: "Supprimer ce tuteur entreprise",
        legal_responsible: "Supprimer ce responsable légal",
      },
      delete_member: {
        title: "Membre du trinôme",
      },
      delete_all_tutor: {
        title: "tous les tuteurs pédagogiques",
      },
      delete_all_map: {
        title: "tous les tuteurs en entreprise",
      },
      edit: {
        legal_responsible: "Modifier ce responsable légal",
        tutor: "Modifier ce tuteur pédagogique",
      },
      contract: {
        title: "Gestion des contrats",
      },
      complete: {
        title: "Ajouter un membre au trinôme",
      },
      actions: {
        title: "Actions",
      },
      add_test: "trinôme test",
      add_test_success: "Trinôme test ajouté avec succès !",
      send_user_infos: "Gérer l'envoi des identifiants",
      send_welcome_email: "Envoyer l'email de bienvenue avec les identifiants",
      send_welcome_email_success: "Email(s) de bienvenue envoyé(s) avec succès !",
      reset_password: "Réinitialiser le mot de passe et renvoyer l'identifiant",
      reset_password_success: "Email(s) de réinitialisation de mot de passe envoyé(s) avec succès !",
      send_user_infos_message: "Cochez les utilisateurs et cliquez sur le type d'email que vous souhaitez leur envoyer",
      add_secondary_user: "Ajouter un utilisateur secondaire pour ce trinôme",
      add_secondary_user_success: "Utilisateur secondaire ajouté avec succès",
      remove_secondary_user: "Utilisateur secondaire supprimé avec succès",
    },
    studeaUser: {
      title: ({ plural }) => plural(["Utilisateur", "Utilisateurs"]),
    },
    user: {
      title: ({ plural }) => plural(["Utilisateur", "Utilisateurs"]),
    },
    crew: {
      title: ({ plural }) => plural(["Groupe", "Groupes"]),
      cannot_remove: "Vous ne pouvez pas supprimer un groupe qui contient des trinômes",
    },
    contract: {
      title: ({ plural }) => plural(["Contrat", "Contrats"]),
      empty: "Ce trinôme ne possède aucun contrat",
      dates: "Dates du contrat",
      company: "Entreprise",
      duration: "Durée",
      address: "Adresse",
      map: "MAP",
      manager: "Gestionnaire",
      contrat_type: "Type de contrat",
      rupture_date: "Date de rupture",
      contract_rupture_date: "Contrat en rupture au : ",
      dropped_out: "Abandon le : ",
      rupture_reason: "Motif de rupture",
      rupture_reason_text: "Commentaire",
      months: "mois",
      also_tutor: "Vous êtes tuteur de ce trinôme",
      incident_sheet: "Une fiche vigilance est en cours sur ce trinôme",
    },
    template: {
      title: ({ plural }) => plural(["Modèle", "Modèles"]),
    },
    lesson: {
      title: ({ plural }) => plural(["Cours", "Cours"]),
    },
    skillType: {
      title: ({ plural }) => plural(["Type de compétence", "Types de compétences", "Type de compétences"]),
    },
    subject: {
      title: ({ plural }) => plural(["Matière", "Matières"]),
      former: {
        add: "Ajouter un formateur",
        add_new: "Ajouter un formateur qui n'est pas dans la liste",
        is_former: "Cet utilisateur est déjà formateur",
        is_studea_manager: "Cet utilisateur est pilote, lui attribuer un nouveau rôle pourrait changer ses droits",
        is_admin: "Cet utilisateur est administrateur, un profil pilote formateur lui sera ajouté",
        empty: "Aucun utilisateur trouvé, renseignez l'email , le nom et le prénom pour créer un nouveau formateur",
        add_success: "Formateur ajouté avec succès",
      },
    },
    unit: {
      title: ({ plural }) => plural(["Unité", "Unités"]),
    },
    planning: {
      title: ({ plural }) => plural(["Évènement", "Évènements"]),
      removeSelected: {
        title: "Supprimer les évènements sélectionnés",
        sub_title: "Êtes-vous sûr de vouloir supprimer ces évènements ?",
        sucess: "Évènements supprimés avec succès !",
      },
      end_of_recurrence: "Fin de la récurrence :",
    },
    trainingCourseModuleTriad: {
      title: ({ plural }) => plural(["Module", "Modules"]),
    },
    absence: {
      title: ({ plural }) => plural(["Absence", "Absences"]),
      list: {
        title: "Assiduité",
      },
      config: {
        title: "Configuration",
        success: "Configuration modifiée avec succès !",
      },
      export: {
        full_list: "Liste complète des absences",
        apprentice_list: "Liste des absences par ",
        excel: "(excel)",
        pdf: "(pdf)",
        state: "État des absences (planning)",
      },
      attestation: {
        title: "Envoyer une notification de nouvelle attestation",
      },
    },
    module: {
      title: ({ plural }) => plural(["Module", "Modules"]),
      active: {
        success: "Module activé avec succès !",
      },
      unactive: {
        success: "Module désactivé avec succès !",
      },
    },
    registration: {
      title: ({ plural }) => plural(["Inscription", "Inscriptions"]),
      list: {
        title: "Inscriptions",
      },
      go_to: "Accéder aux inscriptions",
    },
    notepad: {
      title: ({ plural }) => plural(["Bloc-notes", "Blocs-notes"]),
    },
    note: {
      title: ({ plural }) => plural(["Note", "Notes"]),
    },
    document: {
      title: ({ plural }) => plural(["Document", "Documents"]),
      pedagogic_documents: "Documents pédagogiques",
      general_documents: "Documents généraux",
      shared_documents: "Documents partagés",
      shared_document_add: "Ajout d'un document partagé",
      shared_document_edit: "Modifier un document partagé",
      shared_document_list: "Les documents partagés",
      shared_document_info:
        "Ce document est partagé, pour le modifier veuillez \n vous rendre dans la liste des documents partagés",
      trainingCourse_documents: "Documents de la promotion",
      error_file_or_link: "Veuillez ajouter un fichier ou saisir un lien",
      link: "lien",
    },
    "document/shared": {
      title: ({ plural }) => plural(["Document partagé", "Documents partagés"]),
    },
    incident_sheet: {
      title: ({ plural }) => plural("Fiche vigilance", "Fiches vigilances"),
      list: "Les fiches vigilances",
      add_comment: "Ajouter un commentaire",
      close: "Clôturer",
      close_confirmation: "Êtes-vous sur de vouloir clôturer cette fiche vigilance ?",
      open: "Ouvrir",
      open_confirmation: "Êtes-vous sur de vouloir réouvrir cette fiche vigilance ?",
      delete: "Supprimer",
      delete_confirmation: "Êtes-vous sur de vouloir supprimer cette fiche vigilance ?",
      in_progress: "En cours",
      closed: "Clôturée",
      search: "Rechercher une fiche vigilance",
      see_sheet: "Voir la fiche incident",
      comment: "Commentaire",
      status: "Statut",
      no_status: "Pas de statut",
    },
    currently: "actuellement",
    documentExchange: {
      list: {
        title: "Échange de docs",
      },
    },
    messaging: {
      list: {
        title: "Messagerie",
      },
    },
    dashboard: {
      list: {
        title: "Tableau de bord",
      },
      please_use_filter_to_see_data: "Veuillez utiliser les filtres pour pouvoir visualiser les données",
      signature_cancel_confirmation: "Êtes vous sûr(e) de vouloir annuler la signature ?",
      filter: "Filtrer",
      delete_filters: "Réinitialiser les filtres",
      questionnaire: {
        unlocked_confirmation: "Voulez-vous débloquer ce questionnaire ?",
        locked_confirmation: "Voulez-vous bloquer ce questionnaire ?",
        unlocked_all_confirmation: "Voulez-vous débloquer tous les questionnaires de cette colonne ?",
        unlock_all_questionnaires: "Débloquer tous les questionnaires de cette colonne",
        unlock_questionnaire: "Débloquer ce questionnaire",
        opening_date_on: "Date d'ouverture au",
        lock_questionnaire: "Bloquer ce questionnaire",
        cancel_signature: "Annuler cette signature",
        send_email_reminder: "Relancer par mail",
        send_email_reminder_confirmation: "Êtes-vous sur de vouloir effectuer une relance par mail ?",
        send_email_reminder_success: "Relances envoyées avec succès !",
        success_all_unlock: "Questionnaires débloqués avec succès !",
        success_unlock: "Questionnaire débloqué avec succès !",
        success_lock: "Questionnaire bloqué avec succès !",
        success_cancel_signature: "Signature annulée avec succès !",
        to_much_data: "Trop de données selectionnées, veuillez affiner votre recherche",
        table_lock: "Figer les questionnaires",
        table_unlock: "Ne pas figer les questionnaires",
      },
      mail_relance: "Relances par mail",
      email_reminder: "Relancer par mail",
      export: {
        title: "Exporter",
        all_promotion_replies: "Exporter l'ensemble des réponses de la promotion",
        all_promotion_replies_to_excel: "Exporter l'ensemble des réponses de la promotion au format Excel",
        visit_date: "Exporter les dates de visite en entreprise",
        dashboard_excel: "Exporter le tableau de bord au format Excel",
        questionnaires_pdf: "Exporter les questionnaires",
      },
      roles: {
        alternate: "Alternant",
        educational_tutor: "Tuteur pédagogique",
        company_tutor: "Tuteur en entreprise",
        lea_manager: "Chargé de léa",
      },
      go_to_questionnaire: "Accéder au questionnaire",
    },
    gradeBookDashboard: {
      list: {
        title: "Tableau des notes",
      },
      export_dashboard_excel: "Exporter le tableau des notes au format Excel",
      caption: {
        danger: "Note entre la note minimale et la moyenne inférieure",
        success: "Note entre la moyenne supérieure et la note maximale",
      },
    },
    skillDashboard: {
      list: {
        title: "Tableau de bord des compétences",
      },
      export_dashboard_excel: "Exporter le tableau des compétences au format Excel",
      skill: {
        acquired: "Acquis",
        in_progress: "En cours",
        not_acquired: "Non acquis",
      },
    },
    export: {
      list: {
        title: "Exports",
      },
    },
    mail: {
      list: {
        title: "Suivi des mails",
        empty: "Aucun mail n'a été envoyé pour le moment",
      },
      view: "Voir le contenu du mail",
      data: "Donnée du mail",
    },
    history: {
      list: {
        title: "Historique des connexions",
      },
    },
    assiduite: "Gestion de l'assiduité",
    subscriptions_dashboard: "Tableau de bord des inscriptions",
    import: {
      modele: "Modèle de fichier à télécharger",
      defaultModele: "Modèle de fichier à télécharger (modèle par défaut)",
      triad_new_file:
        "Attention, un nouveau modèle est disponible depuis le 18/09/2023.\n" +
        "          Merci de le télécharger et de l'utiliser pour charger vos trinômes.",
      triad_update:
        "Attention, seuls les membres manquants d'un trinôme seront mis à jour. Aucune donnée (nom, prénom ou email) d'un utilisateur existant ne sera mise à jour.",
      thanks: "Merci de ne pas modifier et / ou supprimer les colonnes du modèle",
    },
    download_file_here: "Télécharger le fichier ICI",
    session: {
      from: "Du",
      to: "au",
      title: ({ plural }) => plural(["Période", "Périodes"]),
    },
    user_never_connected: "Cet utilisateur ne s'est jamais connecté",
    welcome_mail_send: ({ named }) => `Email de bienvenu a été envoyé ${named("number")} fois`,
    reset_password_mail_send: ({ named }) => `Email de réinitialisation a été envoyé ${named("number")} fois`,
    see_last_mail_content: "Voir le contenu du dernier Email envoyé",
    duplication: "Duplication de données",
    duplication_historic: "Historique des duplications",
    search_duplication: "Rechercher des duplications",
    see_duplication: "Voir toutes les informations de cette duplication",
    duplication_date: "Date de fin d'execution",
    duplication_too_old: "Vous ne pouvez pas relancer une duplication vieille de plus de 15 jours.",
    duplication_status: {
      pending: "En cours",
      done: "Finie",
      failed: "Échouée",
    },
    reload_duplication: {
      title: "Relancer cette duplication",
      confirmation: "Êtes-vous sûr de vouloir relancer cette duplciation",
    },
    details: "Détails",
    status: "Statut",
    statistic: {
      title: ({ plural }) => plural(["Statistique", "Statistiques"]),
      shared_documents: "Trinomes incomplets",
      calculation_in_progress: "Calcul des indicateurs en cours.",
      calculation_refresh: "Veuillez patienter un instant ou rafraichir votre page pour actualiser le calcul",
    },
    driver_licence: {
      title: "Permis b",
      requests: "Demandes d'aide au permis B",
      list: "Liste des demandes d'aide au permis B",
      valid: "Valider la demande d'aide",
      valid_confirmation: "Êtes-vous sur de vouloir valider cette demande ?",
      export: "Exporter la liste des demandes d'aide",
      edit: "Modifier la demande de : ",
      overview: "Aperçu de la demande de : ",
      request_edit: {
        success: "Demande d'aide au permis B modifié avec succès",
      },
    },
    company: {
      title: ({ plural }) => plural(["Entreprise", "Entreprises"]),
    },
    apprentice: {
      title: ({ plural }) => plural(["Apprenti", "Apprentis"]),
    },
    duplicated: {
      relaunch: "Relancer",
      reference: "Référence",
      destination: "Destination",
      type: "Type de duplication",
      confirmation: "Êtes-vous sûr de vouloir dupliquer ces données",
      action: {
        replace: "Remplacer",
        add: "Ajouter",
        crush: "Écraser",
        options: {
          title: "Options",
          add_to_current_year: "Ajouter à l'année en cours",
          empty_training_course: "Uniquement sur les promotions vides",
          add_to_due_date: "Ajouter une année aux dates d'échéances",
          overwrite_current_year_only: "Écraser uniquement l'année en cours",
        },
      },
      questionnaire: {
        already_sign_not_affected: "Les questionnaires déjà signés ne seront pas impactés",
        copy_even_if_already_existing: "Les questionnaires seront copiés même si il en existe déjà",
        replace_questionnaire_with_same_name_questionnaire:
          "Les questionnaires portant le <strong>même nom</strong> seront remplacés",
        replace_all: "Les questionnaires existants seront supprimés",
      },
      training_course: {
        duplicated_data: "Données dupliquées",
        add_data_if_empty: "Ajoute les données si elles n'existent pas",
        duplicate_choice: "Vous souhaitez dupliquer",
        duplicate_from_reference: "Permet de copier un livret type sur un ensemble de promotion",
        duplicate_from_year: "Permet d'ajouter une année en dupliquant la configuration de l'année précédente",
      },
    },
    trainingPeriod: {
      title: ({ plural }) => plural(["Semestre", "Semestres"]),
    },
    file: {
      title: ({ plural }) => plural(["Fichier", "Fichiers"]),
    },
  },
  add_session: "Ajouter une période",
  edusign: {
    title: "Edusign",
    synchronize: {
      title: "Lancer la synchronisation chez Edusign",
      confirmation: "Êtes-vous sûr de vouloir lancer la synchronisation chez Edusign ?",
    },
    get_data: {
      title: "Récupérer les absences et présences",
      confirmation: "Êtes-vous sûr de vouloir récupérer les absence et présences d'Edusign ?",
    },
  },
  uniservice: {
    title: "Uniservice",
    get_data: {
      title: "Récupérer les présences",
      confirmation: "Êtes-vous sûr de vouloir récupérer les présences d'Uniservice ?",
    },
    reset: {
      title: "Réinitialiser les présences et absences",
      confirmation: "Êtes-vous sûr de vouloir supprimer les présences et absences des plannings non validés ?",
    },
  },
};
